<div *ngIf="loading_website" class="spinner-container">
    <div class="loader-logo-sec">
        <img class="jba-logo" src="./assets/logos/jba_logo.webp" alt="JBA">
    </div>
    <div class="spinner"></div>
</div>
<span class="skip" [routerLink]="" tabindex="0" [attr.aria-label]="'aria_label.main_content'|translate" role="region"
    (click)="skipToMain()" (keyup.enter)="skipToMain()">
    <h6 class="skip-link"> Skip to Main Content</h6>
</span>
<div class="rvhap-site-mode-main" *ngIf="showAppMode">
    <span class="rvhap-site-mode">
        <span class="rvhap-site-mode-label">
            <fa-icon *ngIf="previewMode===undefined" [icon]="['fas','info-circle']" class="rvhap-site-mode-icon"></fa-icon>
            <span *ngIf="previewMode===undefined">You are viewing <b>{{client_name_label}}</b> in
                {{application_mode_label}} mode</span>
        </span>
    </span>
</div>
<div class="rvhap-site-mode-main" *ngIf="previewMode!==undefined ">
    <span class="rvhap-site-mode-preview">
        <span class="rvhap-site-mode-label-preview" [ngStyle]="{ 'top.px': headerHeight }">
            <fa-icon [icon]="['fas','info-circle']" class="rvhap-site-mode-icon"></fa-icon>
            <span *ngIf="previewMode!==undefined">You are currently viewing a preview of this article. (Please note that it is not yet published.)</span>
        </span>
    </span>
</div>
<header *ngIf="!loading_website">
    <app-header class="header"></app-header>
</header>
<div *ngIf="!loading_website" role="main" class="rvh-main">
    <app-alert></app-alert>
    <router-outlet (activate)="onActivate($event)"></router-outlet>

    <app-footer></app-footer>
</div>